module.exports = __webpack_public_path__ + "img/folder-icon.bee04333.svg";